import React, { FunctionComponent } from 'react'

const StatusBarCompletedIcon: FunctionComponent = () => {
  return (
    <svg
      width="59"
      height="59"
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2305_38118)">
        <path
          d="M29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2076 45.7924 0 29.5 0C13.2076 0 0 13.2076 0 29.5C0 45.7924 13.2076 59 29.5 59Z"
          fill="#BCDEB6"
        />
        <path
          d="M29.5 53C42.4787 53 53 42.4787 53 29.5C53 16.5213 42.4787 6 29.5 6C16.5213 6 6 16.5213 6 29.5C6 42.4787 16.5213 53 29.5 53Z"
          fill="#84B77B"
        />
        <path
          d="M29.5 50C40.8218 50 50 40.8218 50 29.5C50 18.1782 40.8218 9 29.5 9C18.1782 9 9 18.1782 9 29.5C9 40.8218 18.1782 50 29.5 50Z"
          fill="#6D9067"
        />
        <path
          d="M30.013 34.6822C30.9109 35.5801 30.9109 37.1192 30.013 38.0171L28.1532 39.877C27.2553 40.7748 25.7161 40.7748 24.8183 39.877L16.6734 31.668C15.7755 30.7701 15.7755 29.2309 16.6734 28.3331L18.5332 26.4732C19.4311 25.5753 20.9703 25.5753 21.8682 26.4732L30.013 34.6822Z"
          fill="white"
        />
        <path
          d="M37.1317 20.5093C38.0296 19.6115 39.5688 19.6115 40.4666 20.5093L42.3265 22.3692C43.2243 23.267 43.2243 24.8062 42.3265 25.7041L28.2173 39.7492C27.3194 40.647 25.7802 40.647 24.8824 39.7492L23.0225 37.8893C22.1247 36.9915 22.1247 35.4523 23.0225 34.5544L37.1317 20.5093Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2305_38118">
          <rect width="59" height="59" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default StatusBarCompletedIcon
